(function () {

  // ═══════════════════════════════════════════════════════════════
  //  CAMPAÑA OCTUBRE (tema "QWADRUM store theme October Campaign")
  //  - Rutina (cualquier cantidad)        → toalla (las 3 muestras ya
  //                                         van dentro del pack)
  //  - 2 o más productos individuales     → 3 muestras + toalla
  //  - 1 producto individual              → 3 muestras
  //  Máximo por pedido: 3 muestras + 1 toalla.
  //  Los regalos solo se añaden al pulsar "pagar" → no se ven en el
  //  carrito, solo en el checkout.
  // ═══════════════════════════════════════════════════════════════

  // ─── IDs de variante de productos individuales ──────────────────
  const PRODUCTS = {
    ACG:  56061902586204,  // Active cleansing gel
    AASB: 56062152638812,  // Anti-aging after shave balm
    RCYS: 56062167056732,  // Radiance cream young skin
    RCMS: 56062174658908,  // Radiance cream mature skin
    FECC: 56062183440732,  // Flash-acting eye contour cream
    RBNC: 56062227186012,  // Retinal-bakuchiol powered night cream
  };
  const PRODUCT_IDS = Object.values(PRODUCTS);

  // ─── IDs de variante de las rutinas ─────────────────────────────
  const ROUTINE_IDS = [
    56891022803292,  // RUTINA REGENERACIÓN NOCTURNA
    56891024539996,  // RUTINA ESENCIAL (<45)
    56891078705500,  // RUTINA ESENCIAL (≥45)
    59074593358172,  // RUTINA AVANZADA (<45)
    59104678412636,  // RUTINA AVANZADA (≥45)
    59119179661660,  // RUTINA AVANZADA 360º CON CONTORNO DE OJOS (<45)
    59104680214876,  // RUTINA AVANZADA 360º CON CONTORNO DE OJOS (≥45)
  ];

  // ─── IDs de variante de los regalos ─────────────────────────────
  const SAMPLES = {
    S_AASB: 56889935888732,  // Sample anti-aging after shave balm
    S_RCMS: 56889941819740,  // Sample radiance cream mature skin
    S_FECC: 56889952076124,  // Sample flash-acting eye contour cream
  };
  const ALL_SAMPLE_IDS = Object.values(SAMPLES);
  const TOWEL_ID = 58625914405212;          // Qwadrum Facial Towel
  const OLD_BUNDLE_ID = 58625915584860;     // Samples Pack + Towel (agosto, ya no se usa)

  // Todo lo que es regalo: se oculta del carrito y del contador
  const GIFT_IDS = [...ALL_SAMPLE_IDS, TOWEL_ID, OLD_BUNDLE_ID];

  // ─── Ocultar regalos en carrito / cajón y el aviso antiguo de muestras ──
  // (los regalos solo deben verse en el checkout)
  (function injectCss() {
    const sel = GIFT_IDS.map(id => `.cart-item[data-variant-id="${id}"]`).join(',');
    const css = document.createElement('style');
    css.textContent = sel + '{display:none !important;}' +
      '#gift-samples-banner{display:none !important;}';
    document.head.appendChild(css);
  })();

  // ─── Esperar a que el tema termine de guardar cambios del carrito ─
  // (si el cliente pulsa "+" y enseguida "pagar", la cantidad nueva
  //  aún no está guardada; esperamos a que lo esté)
  const nativeFetch = window.fetch.bind(window);
  const pendingCartWrites = new Set();
  let lastQtyChange = 0;
  let checkingOut = false;
  window.fetch = function (input, init) {
    const url = String((input && input.url) || input || '');
    const p = nativeFetch(input, init);
    if (/\/cart\/(change|update|add)/.test(url)) {
      const tracked = p.catch(() => {});
      pendingCartWrites.add(tracked);
      tracked.finally(() => pendingCartWrites.delete(tracked));
    }
    return p;
  };
  // Momento del último cambio de cantidad (botones +/- o escribir en el campo)
  ['change', 'click', 'input'].forEach(ev => document.addEventListener(ev, function (e) {
    if (e.target.closest && e.target.closest('.quantity__input, .quantity__button, quantity-input, cart-remove-button')) {
      lastQtyChange = Date.now();
    }
  }, true));

  function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

  async function waitCartIdle() {
    // 1) Si acaba de cambiar una cantidad, esperar al "debounce" del tema (300 ms)
    const sinceChange = Date.now() - lastQtyChange;
    if (sinceChange < 700) await sleep(700 - sinceChange);
    // 2) Esperar a que terminen los guardados del carrito en curso (máx. 5 s)
    if (pendingCartWrites.size) {
      await Promise.race([Promise.allSettled([...pendingCartWrites]), sleep(5000)]);
    }
  }

  // Leer el carrito siempre "en vivo" (sin caché del navegador, que al
  // volver atrás desde el checkout puede devolver un carrito antiguo)
  function getCart() {
    return nativeFetch('/cart.js?_=' + Date.now(), { cache: 'no-store' }).then(r => r.json());
  }

  // ─── Calcular regalos ────────────────────────────────────────────
  function getGiftsToAdd(cartItems) {
    const realItems = cartItems.filter(i => !GIFT_IDS.includes(i.variant_id));

    const routineQty = realItems
      .filter(i => ROUTINE_IDS.includes(i.variant_id))
      .reduce((sum, i) => sum + i.quantity, 0);

    const productQty = realItems
      .filter(i => PRODUCT_IDS.includes(i.variant_id))
      .reduce((sum, i) => sum + i.quantity, 0);

    // Las rutinas ya llevan las 3 muestras dentro del pack (son componentes
    // del bundle en Shopify) → con rutina solo se añade la toalla.
    if (routineQty >= 1) return [TOWEL_ID];
    if (productQty >= 2) return [...ALL_SAMPLE_IDS, TOWEL_ID];
    if (productQty === 1) return [...ALL_SAMPLE_IDS];
    return [];
  }

  // ─── Quitar todos los regalos ────────────────────────────────────
  async function removeGifts() {
    const updates = {};
    GIFT_IDS.forEach(id => { updates[id] = 0; });
    return nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }

  // ─── Añadir regalos (una sola llamada) ───────────────────────────
  async function addGifts(variantIds) {
    if (!variantIds.length) return;
    return nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: variantIds.map(id => ({ id, quantity: 1, properties: { _gift: 'true' } }))
      })
    });
  }

  // Vuelve a pintar el carrito (página /cart) y el cajón sin recargar la web
  async function refreshCartUI() {
    try {
      const cartItems = document.querySelector('cart-items');
      const section = cartItems && cartItems.closest('.shopify-section');
      if (section && section.id) {
        const sid = section.id.replace('shopify-section-', '');
        const html = await nativeFetch('/cart?section_id=' + encodeURIComponent(sid), { cache: 'no-store' }).then(r => r.text());
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
        if (fresh) cartItems.innerHTML = fresh.innerHTML;
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        const html = await nativeFetch('/?section_id=cart-drawer', { cache: 'no-store' }).then(r => r.text());
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
        if (fresh) {
          const wasOpen = drawer.classList.contains('active');
          drawer.innerHTML = fresh.innerHTML;
          drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
          if (wasOpen) drawer.classList.add('active');
        }
      }
    } catch (err) {
      console.error('[GiftSamples] refreshCartUI error:', err);
    }
  }

  // ─── Limpiar regalos del carrito (para que no se vean) ───────────
  async function cleanCart() {
    if (checkingOut) return;
    try {
      const cart = await getCart();
      const hasGifts = cart.items.some(i => GIFT_IDS.includes(i.variant_id));
      if (hasGifts) {
        await removeGifts();
        // Si el carrito/cajón ya se pintó con los regalos dentro (p. ej. al
        // volver del checkout), volvemos a pintarlo sin ellos para que los
        // botones +/- apunten a la línea correcta (los regalos ya están
        // ocultos por CSS desde el primer momento, no llegan a verse).
        const rendered = GIFT_IDS.some(id =>
          document.querySelector(`[data-variant-id="${id}"]`)
        );
        if (rendered) await refreshCartUI();
      }
      updateCartCount(cart.items);
      setBanner(cart.items);
    } catch (err) {
      console.error('[GiftSamples] cleanCart error:', err);
    }
  }

  // ─── Aplicar regalos justo antes del checkout ────────────────────
  async function applyBeforeCheckout() {
    await waitCartIdle();
    const cart = await getCart();
    const gifts = getGiftsToAdd(cart.items);
    await removeGifts();
    await addGifts(gifts);
  }

  // ─── Interceptar checkout ────────────────────────────────────────
  const CHECKOUT_TEXTS = [
    'checkout', 'pasar por la caja', 'ir al pago', 'tramitar pedido',
    'vai al pagamento', 'vai alla cassa', 'procedi al pagamento',
    'przejdź do kasy', 'przejdź do płatności'
  ];

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('button, a, input[type="submit"]');
    if (!btn) return;

    const text = (btn.innerText || btn.value || '').toLowerCase().trim();
    const href = btn.getAttribute('href') || '';
    const name = btn.getAttribute('name') || '';
    const id   = btn.getAttribute('id')   || '';

    const isCheckout =
      name === 'checkout'            ||
      id   === 'CartDrawer-Checkout' ||
      href.includes('/checkout')     ||
      CHECKOUT_TEXTS.some(t => text.includes(t));

    if (!isCheckout) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    btn.disabled = true;

    try {
      await applyBeforeCheckout();
    } catch (err) {
      console.error('[GiftSamples] checkout error:', err);
    }

    window.location.href = '/checkout';
  }, true);

  // ─── Limpiar al cargar ───────────────────────────────────────────
  // Se ejecuta nada más cargar el script (no esperamos a que carguen
  // todas las apps de la página) y también al volver atrás desde el checkout
  cleanCart();
  window.addEventListener('load', cleanCart);
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    checkingOut = false;
    document.querySelectorAll('button[name="checkout"], #CartDrawer-Checkout').forEach(b => { b.disabled = false; });
    cleanCart();
  });

  // ─── Limpiar en eventos del carrito ─────────────────────────────
  document.addEventListener('click', function (e) {
    const drawerTrigger = e.target.closest('[href="#cart-drawer"], [data-drawer="cart"], .header__icon--cart, [aria-controls="CartDrawer"], .cart-count-bubble, [data-cart-toggle]');
    if (drawerTrigger) setTimeout(cleanCart, 300);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.closest('.quantity__input')) return;
    setTimeout(cleanCart, 800);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('cart-remove-button button')) return;
    setTimeout(cleanCart, 800);
  });
  document.addEventListener('cart:updated', cleanCart);
  document.addEventListener('cart:refresh', cleanCart);

  // ─── Contador del carrito (sin contar regalos) ───────────────────
  function countReal(items) {
    return items
      .filter(i => !GIFT_IDS.includes(i.variant_id))
      .reduce((sum, i) => sum + i.quantity, 0);
  }

  function updateCartCount(items) {
    function applyCount(count) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .visually-hidden').forEach(el => {
        el.textContent = count < 100 ? count : '99+';
      });
      document.querySelectorAll('.cart-count-bubble').forEach(el => {
        el.style.display = count > 0 ? '' : 'none';
      });
    }

    if (items) {
      applyCount(countReal(items));
    } else {
      getCart()
        .then(cart => applyCount(countReal(cart.items)))
        .catch(err => console.error('[GiftSamples] updateCartCount error:', err));
    }
  }

  window.addEventListener('load', () => updateCartCount(null));
  document.addEventListener('cart:updated', e => updateCartCount(e.detail?.cart?.items || null));
  document.addEventListener('cart:refresh', () => updateCartCount(null));

  function setBanner() {}

})();
